// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"ba26ff59","513":"28d5708b"}[chunkId] + ".chunk.js";
};